import React from 'react';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

import { Input } from '@perxis/perxis-auto-ui-kit/lib/components/Input';

import style from './style.module.scss';

export type CaptchaProps = {
  id?: string;
  name?: string;
  value?: string;
  onChange?: (value?: string) => void;
  visible?: boolean;
  sitekey: string;
};

const Captcha: React.FC<CaptchaProps> = ({
  sitekey,
  visible,
  onChange,
  ...props
}: CaptchaProps) => {
  const handleOnSuccess = (token?: string) => {
    onChange?.(token);
  };

  const handleOnNetworkError = () => {
    onChange?.('');
  };

  return (
    <>
      <Input className={style.smartCaptchaInput} {...props} />
      <InvisibleSmartCaptcha
        hideShield
        language="ru"
        sitekey={sitekey}
        visible={visible}
        onSuccess={handleOnSuccess}
        onNetworkError={handleOnNetworkError}
      />
    </>
  );
};

export default Captcha;
